import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

import { protoColors } from '../../theme/tokens';

export const TableWrap = styled(Box)(() => ({
  width: '100%',
  overflowX: 'auto',
}));

export const Table = styled('table')(() => ({
  width: '100%',
  borderCollapse: 'collapse',
  fontSize: '13.5px',
  '& th, & td': {
    padding: '10px 12px',
    textAlign: 'left',
    whiteSpace: 'nowrap',
  },
  '& thead th': {
    color: protoColors.textMuted,
    fontWeight: 600,
    fontSize: '12px',
    textTransform: 'uppercase',
    letterSpacing: '0.03em',
    borderBottom: `1px solid ${protoColors.border}`,
  },
  '& tbody tr': {
    borderBottom: `1px solid ${protoColors.surfaceSubtle}`,
  },
  '& tbody tr:hover': {
    backgroundColor: protoColors.purpleSoft,
  },
  '& td.num, & th.num': {
    textAlign: 'right',
    fontVariantNumeric: 'tabular-nums',
  },
}));

export const HeatBadge = styled('span', {
  shouldForwardProp: (prop) => prop !== 'color',
})<{ color: string }>(({ color }) => ({
  display: 'inline-block',
  minWidth: '58px',
  textAlign: 'center',
  padding: '2px 8px',
  borderRadius: '999px',
  fontWeight: 700,
  fontSize: '12.5px',
  color,
  backgroundColor: `${color}1F`,
}));
